import React, { FunctionComponent, useCallback } from 'react';
import { Translate, useTranslate } from '@pegasus/translation';
import { MessageDialog, Size } from '@lux/dialog';
import { Discounts as DiscountsGraphic } from '@lux/graphics';
import { removeQueryParam } from '@browsing/utils';

import { ExpiredCampaignDialogProps, CampaignExpiredStatus } from './types';

const ExpiredCampaignDialog: FunctionComponent<ExpiredCampaignDialogProps> = ({
    show,
    showStatus,
    onClose,
}) => {
    const translate = useTranslate();
    const handleClose = useCallback(() => {
        removeQueryParam(['event', 'status']);
        onClose();
    }, [onClose]);

    return (
        <MessageDialog
            size={Size.S}
            isShown={show}
            closeLabel={translate('expiredCampaign.close')}
            closeDialog={handleClose}
            graphic={<DiscountsGraphic />}
            title={
                showStatus === CampaignExpiredStatus.NOT_FOUND ? (
                    <Translate message="expiredCampaign.notFoundTitle" />
                ) : (
                    <Translate message="expiredCampaign.expiredCampaignTitle" />
                )
            }
            text={<Translate message="expiredCampaign.subText" />}
            positiveButtonText={<Translate message="expiredCampaign.buttonText" />}
            positiveButtonProps={{ onClick: handleClose }}
        />
    );
};

export default ExpiredCampaignDialog;
